module.exports = __webpack_public_path__ + "img/900714956.317c2c11.png";